import WebAppButton from './button';
import WebPanel from './WebPanel';

export {
  WebAppButton,
};

export default WebPanel;
